var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"Index"}},[_c('div',{staticClass:"title mb-4"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }